var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.643 2v12h10.715V2H2.642Zm2.143 8h6.428c.592 0 1.072.447 1.072 1 0 .553-.48 1-1.072 1H4.786c-.592 0-1.072-.447-1.072-1 0-.553.48-1 1.072-1Zm6.428-3H4.786c-.592 0-1.072.447-1.072 1 0 .553.48 1 1.072 1h6.428c.592 0 1.072-.447 1.072-1 0-.553-.48-1-1.072-1ZM9.071 6H4.786c-.592 0-1.072-.447-1.072-1 0-.553.48-1 1.072-1H9.07c.592 0 1.072.447 1.072 1 0 .553-.48 1-1.072 1Zm4.286-6H2.643C1.46 0 .5.897.5 2v12c0 1.103.961 2 2.143 2h10.714c1.182 0 2.143-.897 2.143-2V2c0-1.103-.961-2-2.143-2Z"
  })));
};
export default SvgDocument;